import { useCreateBaseTournamentForm } from '../use-base-tournament-form';

export const useCreateDdTournamentForm = useCreateBaseTournamentForm;
